import {SET_FINAL_ORDER} from '../types';

export function removeTaker(index){
  return function(dispatch,getState){
    let takeOrders = getState().ui_marketplace.takeOrders
    let order = takeOrders[index]
    takeOrders.splice(index,1)
    dispatch({
      type: SET_FINAL_ORDER,
      payload:{
        takeOrders,
        makerAmount: parseFloat(getState().ui_marketplace.makerAmount) + parseFloat(order.takeAmount),
        takerCollateral:parseFloat(getState().ui_marketplace.takerCollateral) - parseFloat(order.takeCollateral),
        makerCollateral: parseFloat(getState().ui_marketplace.makerCollateral) + parseFloat(order.takeCollateral)
      }
    });
  }
}


export function matchOrdersDispatch(dispatch,getState){
  let price = parseFloat(getState().ui_marketplace.price)
  let amount = getState().ui_marketplace.amount
  let tempAmount = parseFloat(amount);
  let ids = [];
  let summedCollateral = 0;

  if(!price || !amount || price == 0 || amount == 0){
    dispatch({
      type: SET_FINAL_ORDER,
      payload:{takeOrders:[],makerAmount:0,takerCollateral:0,makerCollateral:0,spending:0}
    });
    return;
  }

  let orderType = getState().ui_marketplace.orderType;
  let orders = orderType === "SELL" ? getState().orderbook.sub_demand : getState().orderbook.sub_offers;
  orders = orders.reduce((total,curr)=>{return total.concat(curr.orders)},[]).filter((o)=>{return o!=undefined})

  if(orderType === "BUY") orders.sort((a,b)=> a.price - b.price);
  else orders.sort((a,b)=> b.price - a.price);

  orders.forEach(order => {
    let priceAcceptable = (orderType === "SELL" && order.price >= price) || (order.price <= price && orderType === "BUY" );

    if(priceAcceptable && tempAmount > 0){
      if(parseFloat(order.amount) > tempAmount) {

        let ratio = 100 * tempAmount / parseFloat(order.amount) ;
        let orderRatio = 100 * parseFloat(order.nrgUnit) / parseFloat(order.collateralizedNrg);
        let takeRatio = Math.floor(ratio / orderRatio)

        if(ratio % orderRatio === 0) order.takeAmount = tempAmount;
        else if(takeRatio >= 1){
          order.takeAmount = orderRatio * takeRatio * order.amount / 100;
        }
        order.takeCollateral = parseFloat(order.collateralizedNrg * order.takeAmount / order.amount);
      }
      else {
        order.takeAmount = order.amount
        order.takeCollateral = order.collateralizedNrg
      }

      tempAmount = tempAmount - parseFloat(order.takeAmount);
      summedCollateral += parseFloat(order.takeCollateral)
      ids.push(order);
    }

  });

  dispatch({
    type: SET_FINAL_ORDER,
    payload:{
      takeOrders:ids,
      makerAmount:parseFloat(tempAmount),
      takerCollateral:summedCollateral,
      makerCollateral:parseFloat(tempAmount)
    }
  });

}

export function matchOrders(){
  return function(dispatch,getState){
    matchOrdersDispatch(dispatch,getState)
  }
}
